import React from "react";

export default function downloadIcon({ fill }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 1.5C17.3978 1.5 17.7794 1.65804 18.0607 1.93934C18.342 2.22064 18.5 2.60218 18.5 3V21C18.5 21.3978 18.342 21.7794 18.0607 22.0607C17.7794 22.342 17.3978 22.5 17 22.5H8C7.60218 22.5 7.22064 22.342 6.93934 22.0607C6.65804 21.7794 6.5 21.3978 6.5 21V3C6.5 2.60218 6.65804 2.22064 6.93934 1.93934C7.22064 1.65804 7.60218 1.5 8 1.5H17ZM8 0C7.20435 0 6.44129 0.316071 5.87868 0.87868C5.31607 1.44129 5 2.20435 5 3V21C5 21.7956 5.31607 22.5587 5.87868 23.1213C6.44129 23.6839 7.20435 24 8 24H17C17.7956 24 18.5587 23.6839 19.1213 23.1213C19.6839 22.5587 20 21.7956 20 21V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0L8 0Z"
        fill={fill}
      />
      <path
        d="M9.52344 11.4076L12.5158 14.4L15.5082 11.4076"
        stroke={fill}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5785 13.5546V8.39999"
        stroke={fill}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="8.59998"
        y="15.6"
        width="8.4"
        height="1.2"
        rx="0.6"
        fill={fill}
      />
    </svg>
  );
}
